import { memo } from "react";
import React from "react";
import { some, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { sortBy, tryFind, choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, Autocomplete } from "@mui/material";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { CustomerGroup_fetchGroups } from "../Promises.js";
import { defaultOf, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";

export function Components_CustomerGroupSelect_Z10B6457D(components_CustomerGroupSelect_Z10B6457DInputProps) {
    const selected = components_CustomerGroupSelect_Z10B6457DInputProps.selected;
    const label = components_CustomerGroupSelect_Z10B6457DInputProps.label;
    const onChange = components_CustomerGroupSelect_Z10B6457DInputProps.onChange;
    const groups = components_CustomerGroupSelect_Z10B6457DInputProps.groups;
    const key = components_CustomerGroupSelect_Z10B6457DInputProps.$key;
    const label_1 = defaultArg(label, "Kundegrupper");
    const selectedGroups = defaultArg(map((array_1) => choose((id) => tryFind((group) => (group.Id === id), groups), array_1), selected), []);
    return MuiHelpers_createElement(Autocomplete, toList(delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["multiple", true]), delay(() => append(singleton(["getOptionLabel", (group_1) => group_1.Name]), delay(() => append(singleton(["options", Array.from(groups)]), delay(() => append((selected != null) ? singleton(["value", Array.from(selectedGroups)]) : empty(), delay(() => append(singleton(["onChange", (_arg, v, _arg_1) => {
        const groups_1 = v;
        console.debug("Group select", groups_1);
        onChange(groups_1);
    }]), delay(() => singleton(["renderInput", (p) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p), delay(() => singleton(["label", label_1]))))))]))))))))))))))));
}

export const Components_CustomerGroupSelect_Z6A6DEF5D = memo((components_CustomerGroupSelect_Z6A6DEF5DInputProps) => {
    const selected = components_CustomerGroupSelect_Z6A6DEF5DInputProps.selected;
    const onChange = components_CustomerGroupSelect_Z6A6DEF5DInputProps.onChange;
    const key = components_CustomerGroupSelect_Z6A6DEF5DInputProps.$key;
    const patternInput = reactApi.useState([]);
    const groups = patternInput[0];
    const selectedGroups = defaultArg(map((ids) => choose((id) => tryFind((group) => (group.Id === id), groups), ids), selected), []);
    reactApi.useEffect(() => {
        const pr = CustomerGroup_fetchGroups(false);
        pr.then((res) => {
            if (res.tag === 0) {
                patternInput[1](sortBy((_arg) => _arg.Name, res.fields[0], {
                    Compare: comparePrimitives,
                }));
            }
            else {
                console.error(some("Error fetching customer groups"), res.fields[0]);
            }
        });
    }, []);
    return MuiHelpers_createElement(Autocomplete, toList(delay(() => append(singleton(["multiple", true]), delay(() => append(singleton(["options", Array.from(groups)]), delay(() => append(singleton(["getOptionLabel", (group_1) => group_1.Name]), delay(() => append((selected != null) ? singleton(["value", Array.from(selectedGroups)]) : empty(), delay(() => append(singleton(["onChange", (_arg_1, v, _arg_1_1) => {
        const groups_2 = v;
        console.debug("Group select", groups_2);
        onChange(groups_2);
    }]), delay(() => singleton(["renderInput", (p) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p), delay(() => append(singleton(["size", "small"]), delay(() => singleton(["label", "Kundegrupper"]))))))))]))))))))))))));
});

export function Components_CustomerGroupSelect_Z3E74A903(components_CustomerGroupSelect_Z3E74A903InputProps) {
    const onlyPtg = components_CustomerGroupSelect_Z3E74A903InputProps.onlyPtg;
    const selected = components_CustomerGroupSelect_Z3E74A903InputProps.selected;
    const onChange = components_CustomerGroupSelect_Z3E74A903InputProps.onChange;
    const label = components_CustomerGroupSelect_Z3E74A903InputProps.label;
    const key = components_CustomerGroupSelect_Z3E74A903InputProps.$key;
    const onlyPtg_1 = defaultArg(onlyPtg, false);
    const patternInput = reactApi.useState([]);
    reactApi.useEffect(() => {
        const pr = CustomerGroup_fetchGroups(onlyPtg_1);
        pr.then((res) => {
            if (res.tag === 0) {
                patternInput[1](sortBy((_arg) => _arg.Name, res.fields[0], {
                    Compare: comparePrimitives,
                }));
            }
            else {
                console.error(some("Error fetching customer groups"), res.fields[0]);
            }
        });
    }, []);
    return MuiHelpers_createElement(Autocomplete, [["size", "small"], ["getOptionLabel", (group) => group.Name], ["isOptionEqualToValue", (x_1) => ((y_1) => (x_1.Id === y_1.Id))], ["options", Array.from(patternInput[0])], ["value", defaultArg(selected, defaultOf())], ["onChange", (_arg_1, v, _arg_1_1) => {
        const group_1 = v;
        console.debug("Group select", group_1);
        onChange(group_1);
    }], ["renderInput", (p) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p), delay(() => singleton(["label", label]))))))]]);
}

